import React, { useEffect, useState } from 'react';
import { Card, Button, Table, Modal, Form, Row, Col, Toast, ToastContainer } from 'react-bootstrap';
import { useConfig } from "../utils/ConfigContext.jsx";
import { createAxiosInstance } from "../utils/AxiosInstance.jsx";
// --- Modules Card ---
const ModulesCard = ({ AxiosInstance }) => {
    const [modules, setModules] = useState([]);
    const [parentModules, setParentModules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentModule, setCurrentModule] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastType, setToastType] = useState('success');

    const getModules = async () => {
        try {
            const res = await AxiosInstance.get('/modules');
            const modulesData = res.data.data || [];
            setModules(modulesData);
            setParentModules(modulesData);
        } catch (error) {
            console.error("Error fetching modules:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getModules();
    }, []);

    // const handleShow = (module = {}) => {
    //     if (module.mm_id) {
    //         // Edit mode: map API response fields to form fields
    //         // mm_parent contains the parent module ID
    //         const parentId = (module.mm_parent && module.mm_parent !== 0) ? String(module.mm_parent) : '';

    //         setCurrentModule({
    //             id: module.mm_id,
    //             mm_id: module.mm_id,
    //             name: module.mm_module_name,
    //             link: module.mm_homepage_link,
    //             icon: module.mm_icon,
    //             parent_module_id: parentId,
    //         });
    //         setIsEditing(true);
    //     } else {
    //         // Add mode: clear form
    //         setCurrentModule({});
    //         setIsEditing(false);
    //     }
    //     setShowModal(true);
    // };

    const handleShow = (module = {}) => {
        if (module.mm_id) {
            setCurrentModule({
                id: module.mm_id,
                mm_id: module.mm_id,
                name: module.mm_module_name || '',
                link: module.mm_homepage_link || '',
                icon: module.mm_icon || '',
                parent_module_id:
                    module.parent_id && module.parent_id !== 0
                        ? String(module.parent_id)
                        : '',
            });
            setIsEditing(true);
        } else {
            setCurrentModule({
                name: '',
                link: '',
                icon: '',
                parent_module_id: '',
            });
            setIsEditing(false);
        }
        setShowModal(true);
    };


    const handleClose = () => setShowModal(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formData = new FormData();
            formData.append("name", currentModule.name);
            // formData.append("parent_module_id", currentModule.parent_module_id || null);
            formData.append(
                "parent_module_id",
                currentModule.parent_module_id || 0
            );
            formData.append("link", currentModule.link);
            if (currentModule.icon) {
                formData.append("icon", currentModule.icon);
            }

            if (isEditing) {
                await AxiosInstance.patch(`/modules/${currentModule.id}`, formData);
                setToastMessage('Module updated successfully!');
            } else {
                await AxiosInstance.post("/modules", formData);
                setToastMessage('Module created successfully!');
            }

            setToastType('success');
            setShowToast(true);
            handleClose();
            getModules(); // Refresh list
        } catch (error) {
            console.error("Error saving module:", error);
            setToastMessage('Error saving module. Please try again.');
            setToastType('danger');
            setShowToast(true);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this module?')) return;

        try {
            await AxiosInstance.delete(`/modules/${id}`);
            setModules(prev => prev.filter(m => m.mm_id !== id));
            setToastMessage('Module deleted successfully!');
            setToastType('success');
            setShowToast(true);
        } catch (error) {
            console.error("Error deleting module:", error);
            setToastMessage('Error deleting module');
            setToastType('danger');
            setShowToast(true);
        }
    };

    const handleChangeStatus = async (id, currentStatus) => {
        try {
            const newStatus = currentStatus === 1 ? 0 : 1;
            const formData = new FormData();
            formData.append("status", newStatus);

            await AxiosInstance.patch(`/modules/${id}`, formData);

            setModules(prev =>
                prev.map(m =>
                    m.mm_id === id ? { ...m, mm_module_status: newStatus } : m
                )
            );

            setToastMessage(`Module ${newStatus === 1 ? 'activated' : 'deactivated'} successfully!`);
            setToastType('success');
            setShowToast(true);
        } catch (error) {
            console.error("Error updating module status:", error);
            setToastMessage('Error updating module status');
            setToastType('danger');
            setShowToast(true);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCurrentModule(prev => ({ ...prev, [name]: value }));
    };

    if (loading) return <p>Loading modules...</p>;

    return (
        <Card className="shadow-sm mb-3">
            <Card.Header className="d-flex justify-content-between align-items-center  text-white">
                <h5 className="mb-0">Module List</h5>
                <Button variant="light bg-success text-white" onClick={() => handleShow()}>
                    <i className="ri-add-circle-line me-2"></i> Add New Module
                </Button>
            </Card.Header>
            <Card.Body>
                <Table striped bordered hover responsive size="sm">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Parent Module</th>
                            <th>Link</th>
                            <th>Icon</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modules.map((module) => (
                            <tr key={module.mm_id}>
                                <td>{module.mm_module_name}</td>
                                <td>{module.parent_name || '-'}</td>
                                <td><code>{module.mm_homepage_link}</code></td>
                                <td>
                                    {/* <i className={module.mm_icon} style={{ fontSize: '24px' }}></i> */}
                                    {module.mm_icon?.includes('/') ? (
                                        <img
                                            src={module.mm_icon}
                                            alt="icon"
                                            width="24"
                                            height="24"
                                        />
                                    ) : (
                                        <i className={module.mm_icon} style={{ fontSize: '24px' }}></i>
                                    )}

                                </td>
                                <td>
                                    <span 
                                        className={`badge ${module.mm_module_status === 1 ? 'bg-success' : 'bg-danger'}`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleChangeStatus(module.mm_id, module.mm_module_status)}
                                        title="Click to toggle status"
                                    >
                                        {module.mm_module_status === 1 ? 'Active' : 'Inactive'}
                                    </span>
                                </td>
                                <td>
                                    <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleShow(module)}>
                                        <i className="ri-edit-line"></i>
                                    </Button>
                                    {/* <Button variant="outline-danger" size="sm" onClick={() => handleDelete(module.id)}>
                                        <i className="ri-delete-bin-line"></i>
                                    </Button> */}
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => handleDelete(module.mm_id)}
                                    >
                                        <i className="ri-delete-bin-line"></i>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {/* Add/Edit Modal */}
                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header closeButton className="bg-success text-white">
                        <Modal.Title>{isEditing ? 'Edit Module' : 'Add New Module'}</Modal.Title>
                    </Modal.Header>

                    <Form onSubmit={handleSubmit} encType="multipart/form-data">
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label>Module Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={currentModule.name || ''}
                                    onChange={handleChange}
                                    placeholder="Enter module name"
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Select Parent Module</Form.Label>
                                
                                <Form.Select
                                    name="parent_module_id"
                                    value={currentModule.parent_module_id}
                                    onChange={handleChange}
                                >
                                    <option value="">-- None (Top Level) --</option>

                                    {parentModules
                                        .filter(m =>
                                            m.parent_id === 0 &&            // only top-level
                                            m.mm_id !== currentModule.mm_id // cannot select itself
                                        )
                                        .map(m => (
                                            <option key={m.mm_id} value={String(m.mm_id)}>
                                                {m.mm_module_name}
                                            </option>
                                        ))}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Link (Route)</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="link"
                                    value={currentModule.link || ''}
                                    onChange={handleChange}
                                    placeholder="e.g., /dashboard/modules"
                                   
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Icon (CSS Class)</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="icon"
                                    value={currentModule.icon || ''}
                                    onChange={handleChange}
                                    placeholder="e.g., ri-dashboard-line"
                                />
                                {currentModule.icon && (
                                    <div className="mt-2">
                                        <small className="text-muted">Preview:</small>
                                        <i className={currentModule.icon} style={{ fontSize: '24px', marginLeft: '10px' }}></i>
                                    </div>
                                )}
                            </Form.Group>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Close</Button>
                            <Button variant="success" type="submit">
                                {isEditing ? 'Save Changes' : 'Create Module'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* Toast Notification */}
                <ToastContainer position="top-end" className="p-3" style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999 }}>
                    <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide bg={toastType}>
                        <Toast.Header closeButton>
                            <strong className="me-auto">{toastType === 'success' ? '✓ Success' : '✕ Error'}</strong>
                        </Toast.Header>
                        <Toast.Body className={toastType === 'success' ? 'text-dark' : 'text-white'}>
                            {toastMessage}
                        </Toast.Body>
                    </Toast>
                </ToastContainer>
            </Card.Body>
        </Card>
    );
};

// --- Main Page ---
const Modules = () => {
    const { API_BASE_URL } = useConfig();
    const AxiosInstance = createAxiosInstance(API_BASE_URL);

    return (
        <>
            <style>{`
                .modal-backdrop {
                    height: 100% !important;
                    width: 100% !important;
                }
            `}</style>

            <div className=" mb-5">
                <Row className="g-4">

                    <Col lg={12}>
                        <ModulesCard AxiosInstance={AxiosInstance} />
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default Modules;
